import useABTestValue from '@hooks/useABTestValue'

export type UseEnableDelayedDeBoostingEvents = () => boolean

const useEnableDelayedDeBoostingEvents: UseEnableDelayedDeBoostingEvents = () =>
  useABTestValue('enableDelayedDeBoostingEvent') === 'active'

export default useEnableDelayedDeBoostingEvents
